import { render, staticRenderFns } from "./ListenConfig.vue?vue&type=template&id=2ca68c04&scoped=true&"
import script from "./ListenConfig.vue?vue&type=script&lang=js&"
export * from "./ListenConfig.vue?vue&type=script&lang=js&"
import style0 from "./ListenConfig.vue?vue&type=style&index=0&id=2ca68c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca68c04",
  null
  
)

export default component.exports